import { DadosEmpresa } from './DadosEmpresa'
import { DadosEndereco } from './DadosEndereco'
import { DadosResponsavel } from './DadosResponsavel'

export function DadosCadastrais() {
    return (
        <section id="dados-cadastrais">
            <DadosEmpresa />
            <DadosResponsavel />
            <DadosEndereco />
        </section>
    )
}
